import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../theme';

export const useQuoteContentLargeStyles = createStyles(() => ({
  flightItinerary: {
    '.MapCard': {
      height: 400,
    },

    // Flips the padding and mirrors the waypoint route line for the
    // delivery-side ShipmentDetails, which always renders as the sibling
    // immediately after this column.
    '& + .ant-col > .ShipmentDetails': {
      paddingLeft: ThemeSpaces.SPACE_XL,
      paddingRight: 0,

      '.waypoint-line-wrapper': {
        transform: 'translateX(-100%)',
        left: 0,
      },
    },
  },
}));
